import PropTypes from 'prop-types';
import Collapse from './Collapse';
import { ICON } from './icon';
import { Form } from 'antd';
import classNames from 'classnames';
import { useCallback } from 'react';
import { Events, scroller } from 'react-scroll';

export default function Question({
    checkedError = false,
    dsBreachTemplate = [],
}) {
    const form = Form.useFormInstance();
    const part = Form.useWatch('part', form) ?? [];

    const isQuestionChecked = (key) => {
        return part?.some((group) =>
            group?.groupQuestion?.some((item) => {
                return item.storyId === key;
            })
        );
    };

    const isAllChecked = dsBreachTemplate?.every((item) => {
        if (!item.required) return true;
        return isQuestionChecked(item.value);
    });

    const getIcon = (key, required) => {
        const checked = isQuestionChecked(key);
        if (!required) {
            return checked ? ICON[7] : ICON[6];
        }
        if (checked) {
            return ICON[7];
        }
        return checkedError ? ICON[8] : ICON[6];
    };

    const getIdInGroupQuestionByValue = (value) => {
        return part?.flatMap((group) => {
            return group?.groupQuestion?.flatMap((item) => {
                if (item.storyId === value) {
                    return item.id;
                }
                return [];
            });
        })[0];
    };

    const scrollToWithContainer = useCallback((id) => {
        const goToContainer = new Promise((resolve) => {
            Events.scrollEvent.register('end', () => {
                resolve();
                Events.scrollEvent.remove('end');
            });

            scroller.scrollTo('form-breach', {
                duration: 300,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        });

        goToContainer.then(() =>
            scroller.scrollTo(id, {
                duration: 300,
                delay: 0,
                smooth: 'easeInOutQuart',
                containerId: 'form-breach',
                offset: -100,
            })
        );
    }, []);

    return (
        <div className="w-80 shadow-lg rounded-lg">
            <Collapse
                defaultOpen
                error={checkedError && !isAllChecked}
                title="ชุดคำถามที่ควรมีในแบบฟอร์มนี้"
            >
                {!isAllChecked && checkedError && (
                    <p className="text-red-500">
                        กรุณาตรวจสอบรายการด้านล่าง
                        และกำหนดหัวข้อที่ควรมีในแบบฟอร์มให้ครบถ้วน
                    </p>
                )}
                {dsBreachTemplate?.map((item) => (
                    <button
                        type="button"
                        key={item.value}
                        className={classNames(
                            'py-2 flex items-center gap-2 text-left w-full duration-200 transition-all',
                            {
                                'hover:bg-purple-PHX/20 rounded-md':
                                    isQuestionChecked(item.value),
                                'cursor-default': !isQuestionChecked(
                                    item.value
                                ),
                            }
                        )}
                        onClick={() => {
                            const id = getIdInGroupQuestionByValue(item.value);
                            if (id) {
                                scrollToWithContainer(id);
                            }
                        }}
                    >
                        <span className="flex-shrink-0">
                            {getIcon(item.value, item.required)}
                        </span>
                        {item.label} {item.required && <span>*</span>}
                    </button>
                ))}
            </Collapse>
        </div>
    );
}
Question.propTypes = {
    checkedError: PropTypes.bool,
    dsBreachTemplate: PropTypes.array,
};
